import { render, staticRenderFns } from "./examination-add-or-update.vue?vue&type=template&id=239dad9a&scoped=true&"
import script from "./examination-add-or-update.vue?vue&type=script&lang=js&"
export * from "./examination-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./examination-add-or-update.vue?vue&type=style&index=0&id=239dad9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239dad9a",
  null
  
)

export default component.exports